"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IFRAME_COMMS_MESSAGE_TYPE = exports.DASHBOARD_UI_FILTER_CONFIG_URL_PARAM_KEY = void 0;
const IFRAME_COMMS_MESSAGE_TYPE = "__embedded_comms__";
exports.IFRAME_COMMS_MESSAGE_TYPE = IFRAME_COMMS_MESSAGE_TYPE;
const DASHBOARD_UI_FILTER_CONFIG_URL_PARAM_KEY = {
  visible: "show_filters",
  expanded: "expand_filters"
};
exports.DASHBOARD_UI_FILTER_CONFIG_URL_PARAM_KEY = DASHBOARD_UI_FILTER_CONFIG_URL_PARAM_KEY;